import { BRANDS } from "../../../configs";

const toFieldAdapter = (data, brand) => {
	const sortAlphabetically = (a, b) => a?.Name.localeCompare(b?.Name);

	let allDestinations = data?.Regions?.reduce((accumulator, region) => {
		const destinationsInRegion = region?.DestinationGroups?.sort(sortAlphabetically)?.reduce(
			(_accumulator, destinationGroup) => {
				if (destinationGroup?.Destinations?.length > 0) {
					const destinations = destinationGroup.Destinations?.filter(
						destination =>
							!destination?.AdditionalInformation?.some(
								info => info?.code === "IsDisplay" && info?.value === "false"
							)
					)
						?.sort(sortAlphabetically)
						.map(destination => {
							let label = `${destination?.Name}, ${destination?.CountryName} (${destination?.Code})`;

							if (destination?.Name === destination?.CountryName) {
								label = `${destination?.Name} (${destination?.Code})`;
							}

							return {
								label,
								value: destination?.ProviderCode,
							};
						});

					if (destinations?.length) {
						accumulator.push({
							title: destinationGroup?.Name,
							items: destinations,
						});
					}
				}

				return _accumulator;
			},
			[]
		);

		return [...accumulator, ...destinationsInRegion];
	}, []);

	if (brand === BRANDS.SOV) {
		allDestinations = data.reduce((acc, item) => {
			const locationGroupName = item.location.trim().split(", ")[0];

			const existingGroup = acc.find(group => group.title === locationGroupName);

			if (existingGroup) {
				existingGroup.items.push({ label: item?.name, value: item?.code });
			} else {
				acc.push({
					title: locationGroupName,
					items: [{ label: item?.name, value: item?.code }],
				});
			}

			return acc;
		}, []);
	}

	return [allDestinations];
};

export default toFieldAdapter;
